import {
    GET_AGENT_CODE,
    GET_BANKS_REFERENCE_DATA_VALUE,
    GET_BRANCH_CODES_REFERENCE_DATA_VALUE,
    setSizotsaApiDetails,
    setSizotsaReferenceDetailsValue,
} from '../../../actions/sizotsaFuneralCover/referenceData';
import axios from 'axios';
import { API_CALL_STATUS } from '../../../reducers/status';

export const referenceDataService = (store, next, action) => {
    const result = next(action);
    if (action.type === GET_BANKS_REFERENCE_DATA_VALUE) {
        (async () => {
            const bankReferenceData = await fetchBankReferenceData();
            if (bankReferenceData) {
                store.dispatch(setSizotsaReferenceDetailsValue({value:bankReferenceData.data,fieldType:'banks'}));
            } else {
                store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.FAILURE,name:'banksService'}));
            }
        })();
    }
    if (action.type === GET_BRANCH_CODES_REFERENCE_DATA_VALUE) {
        (async () => {
            store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.PENDING,name:'branchCodesService'}));
            const branchCodesReferenceData = await fetchBranchCodesReferenceData(action.value);
            if (branchCodesReferenceData) {
                store.dispatch(setSizotsaReferenceDetailsValue({value:branchCodesReferenceData.data,fieldType:'branchCodes'}));
                store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.SUCCESS,name:'branchCodesService'}));
            } else {
                store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.FAILURE,name:'branchCodesService'}));
            }
        })();
    }
    if (action.type === GET_AGENT_CODE) {
        (async () => {
            store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.PENDING,name:'agentCodeService'}));
            const agentCode = await getAgentCode(action.value);
            if (agentCode) {
                store.dispatch(setSizotsaReferenceDetailsValue({value:agentCode.data,fieldType:'agentCodeDetails'}));
                store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.SUCCESS,name:''}));
            } else {
                store.dispatch(setSizotsaApiDetails({status:API_CALL_STATUS.FAILURE,name:''}));
            }
        })();
    }
    return result;
};

const fetchBankReferenceData = async () => {
    try {
        const response = await axios.get('/om-api/sizotsa-funeral/eswatini-banks', {
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Access-Control-Allow-Origin': '*',
            },
        });
        return response;
    } catch (error) {
        return null;
    }
};
const fetchBranchCodesReferenceData = async (bankCode) => {
    try {
        const response = await axios({
            url: `/om-api/sizotsa-funeral/eswatini-banks/branches/${bankCode}`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
                'Access-Control-Allow-Origin': 'null',
            },
        });
        return response;
    } catch (error) {
        return null;
    }
};
export const getAgentCode = async (agentCode) => {
    try {
        const response = await axios({
            url: `/om-api/sizotsa-funeral/getEsAgent/${agentCode}`,
            method: 'get',
            headers: {
                'Content-Type': 'application/json',
                Accept: 'application/json',
            },
        });
        return response;
    } catch (error) {
        return null;
    }
};